import { ActionTree, MutationTree } from 'vuex'
import { getNotifications, updateNotification } from './apis'
import { INotificationAction, INotificationActionsTypes, INotificationFetchRequest, INotificationReadRequest, INotificationMutation, INotificationMutationTypes, INotificationState } from './interfaces'
import { IRootState } from '@/store'

const state = (): INotificationState => ({
  loading: false,
  notifications: []
})

const mutations: MutationTree<INotificationState> & INotificationMutation = {
  [INotificationMutationTypes.SET_LOADING] (state, payload: boolean): void {
    state.loading = payload
  },
  [INotificationMutationTypes.SET_NOTIFICATION] (state, payload: any): void {
    state.notifications = payload
  }
}

const actions: ActionTree<INotificationState, IRootState> & INotificationAction = {

  async [INotificationActionsTypes.FETCH_NOTIFICATIONS] ({ commit }, dto: INotificationFetchRequest) {
    commit(INotificationMutationTypes.SET_LOADING, true)
    const data = await getNotifications(dto)
    if (data?.data) {
      commit(INotificationMutationTypes.SET_NOTIFICATION, data?.data)
    }
    commit(INotificationMutationTypes.SET_LOADING, false)
  },

  async [INotificationActionsTypes.UPDATE_NOTIFICATION] ({ commit }, dto: INotificationReadRequest) {
    commit(INotificationMutationTypes.SET_LOADING, true)
    await updateNotification(dto)
    commit(INotificationMutationTypes.SET_LOADING, false)
  }
}

const NotificationModule = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default NotificationModule
